import onKeyboardDelete from '../actions/actionCreators/onKeyboardDelete';
import { orchestrator } from 'satcheljs';
import { resetFocus } from 'owa-mail-focus-manager';
import {
    doesUserHaveSharedFolderPermissionFor,
    MenuItemType,
} from 'owa-mail-filterable-menu-behavior';
import deleteMailListRows from 'owa-mail-triage-action/lib/actions/deleteMailListRows';
import emptyTableView from 'owa-mail-triage-action/lib/actions/emptyTableView';
import deleteItemsBasedOnNodeIds from 'owa-mail-triage-action/lib/actions/actionCreators/deleteItemsBasedOnNodeIds';

// Orchestrator for keyboard delete on both item parts and rows
export default orchestrator(onKeyboardDelete, actionMessage => {
    const {
        tableView,
        selectedNodeIds,
        selectedRowKeys,
        isInVirtualSelectAllMode,
        isExplicitSoftDelete,
    } = actionMessage;

    // Disable row deletion if the row is in a shared folder and user doesn't have delete permissions
    if (!doesUserHaveSharedFolderPermissionFor(MenuItemType.Delete)) {
        return;
    }

    if (isInVirtualSelectAllMode) {
        // When in virtual select all mode, i.e select all mode in non-search,
        // delete all in the folder
        emptyTableView(
            tableView,
            isExplicitSoftDelete,
            'Keyboard',
            tableView.virutalSelectAllExclusionList
        );
    } else {
        // Is item part operation
        if (selectedNodeIds.length > 0) {
            deleteItemsBasedOnNodeIds(selectedNodeIds, tableView.id, 'Keyboard');
            resetFocus();
            return;

            // Is row operation
        } else {
            if (selectedRowKeys.length > 0) {
                deleteMailListRows(selectedRowKeys, tableView.id, isExplicitSoftDelete, 'Keyboard');
            }
        }
    }

    if (tableView.rowKeys.length == 0) {
        // Set focus on the container such that it doesn't get
        // lost when the deleted item is the last one in the current folder
        resetFocus();
    }
});
